module.exports = __webpack_public_path__ + "static/img/14.485edca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/sp/14.png
// module id = SU7O
// module chunks = 0